import React from 'react';
import RiskManagementView from "./RiskManagementView"
function RiskManagement(props) {
    return (
        <RiskManagementView/>
    );
}

export default RiskManagement;
